export default __webpack_public_path__ + "static/media/photo-soon.f29a293a.svg";